import React from "react";
import ToolbarWithHeading from "./ToolbarWithHeading";

const ExecutiveDashboardToolbar = () => {
  return <ToolbarWithHeading>Corporate Dashboard</ToolbarWithHeading>;
};

export default ExecutiveDashboardToolbar;
